import {
  type schemaType,
  type paramsType,
  type returnType,
} from '~~/shared/api/rurality/v3/search/seo/facet/schema'
import {
  serverFetchWrapperMeta,
  browserFetchWrapperMeta,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/search/seo/facet'

export const serverFetch = (params: paramsType): Promise<returnType> =>
  serverFetchWrapperMeta<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  browserFetchWrapperMeta<paramsType, schemaType>(endpoint, params)
